import axios from 'axios';

export const state = {};

export const getters = {};

export const mutations = {};

export const actions = {
    async getSpecialities() {
        const { data } = await axios.get('/lookups/specialities');

        return data;
    },

    async getJobTypes() {
        const { data } = await axios.get('/lookups/job-types');

        return data;
    }
};
